<template>
    <div class="main-bg">
      <p style="float: left;">菜品种类</p>
      <el-button
        size="mini"
        type="primary"
        style="float: right"
        @click="addType">添加菜品</el-button>
      <el-table
        :data="typeList"
        style="width: 100%"
      >
        <el-table-column
          prop="vegetableName"
          align="center"
          label="菜品名称">
        </el-table-column>
        <el-table-column
          prop="dr"
          align="center"
          label="状态">
          <template slot-scope="scope">
            {{scope.row.vegetableStatus==1020?'已下架':'在使用'}}
          </template>
        </el-table-column>
        <el-table-column
          prop="status"
          label="操作"
          fixed="right"
          align="center">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="primary"
              v-if="scope.row.vegetableStatus==1020"
              @click="changeStatus(scope.row)">上架</el-button>
            <el-button
              size="mini"
              type="danger"
              v-if="scope.row.vegetableStatus==1002"
              @click="changeStatus(scope.row)">下架</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-divider></el-divider>
      <p style="float: left;">购买人</p>
      <el-button
        size="mini"
        type="primary"
        style="float: right;"
        @click="addPeople">添加购买人</el-button>
      <el-table
        :data="peopleList"
        style="width: 100%"
      >
        <el-table-column
          prop="userName"
          align="center"
          label="购买人">
        </el-table-column>
        <el-table-column
          prop="dr"
          align="center"
          label="状态">
          <template slot-scope="scope">
            {{scope.row.userStatus==1020?'已下架':'在使用'}}
          </template>
        </el-table-column>
        <el-table-column
          prop="status"
          label="操作"
          fixed="right"
          align="center">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="primary"
              v-if="scope.row.userStatus==1020"
              @click="changePeople(scope.row)">上架</el-button>
            <el-button
              size="mini"
              type="danger"
              v-if="scope.row.userStatus==1002"
              @click="changePeople(scope.row)">下架</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
</template>

<script>
  import axios from 'axios'
    export default {
        name: "dict",
      data(){
          return{
            typeList:[],
            peopleList:[],
          }
      },
      mounted(){
          this.getType()
          this.getPeople()
      },
      methods:{
        getType(){
          var that=this
          axios.post('api/vegetable_user_type/getVegetableTypeStatusAll',{

          }).then(function (res) {

              if (res.data.code==2000){
                that.typeList=res.data.body
                console.log(that.typeList)
              }else{
                that.$message.error(res.data.msg);
              }
            }
          )
        },
        getPeople(){
          var that=this
          axios.post('api/vegetable_user_type/getVegetableUserStatusAll',{

          }).then(function (res) {

              if (res.data.code==2000){
                that.peopleList=res.data.body
              }else{
                that.$message.error(res.data.msg);
              }
            }
          )
        },
        changeStatus(row){
          var that=this
          let body={
            vegetableId:row.vegetableId,
            vegetableName:row.vegetableName,
            vegetableStatus:row.vegetableStatus=="1002"?'1020':'1002',
          }
          axios.post('api/vegetable_user_type/updateVegetableType',{
            body
          }).then(function (res) {

              if (res.data.code==2000){
                that.$message({
                  type: 'success',
                  message: '修改成功!'
                });
                that.getType()
              }else{
                that.$message.error(res.data.msg);
              }
            }
          )
        },
        changePeople(row){
          var that=this
          let body={
            userId:row.userId,
            userName:row.userName,
            userStatus:row.userStatus=="1002"?'1020':'1002',
          }
          axios.post('api/vegetable_user_type/updateVegetableUser',{
            body
          }).then(function (res) {

              if (res.data.code==2000){
                that.$message({
                  type: 'success',
                  message: '修改成功!'
                });
                that.getPeople()
              }else{
                that.$message.error(res.data.msg);
              }
            }
          )
        },
        addPeople(){
          var that=this
          this.$prompt('请输入购买人姓名', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
          }).then(({ value }) => {
            let body={
              userName:value,
              userStatus:1002
            }
            axios.post('api/vegetable_user_type/saveVegetableUser',{
              body
            }).then(function (res) {

                if (res.data.code==2000){
                  that.$message({
                    type: 'success',
                    message: '添加成功!'
                  });
                  that.getPeople()
                }else{
                  that.$message.error(res.data.msg);
                }
              }
            )

          }).catch(() => {
            this.$message({
              type: 'info',
              message: '取消输入'
            });
          });
        },
        addType(){
          var that=this
          this.$prompt('请输入菜品名称', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
          }).then(({ value }) => {
            let body={
              vegetableName:value,
              vegetableStatus:1002
            }
            axios.post('api/vegetable_user_type/saveVegetableType',{
              body
            }).then(function (res) {

                if (res.data.code==2000){
                  that.$message({
                    type: 'success',
                    message: '添加成功!'
                  });
                  that.getType()
                }else{
                  that.$message.error(res.data.msg);
                }
              }
            )

          }).catch(() => {
            this.$message({
              type: 'info',
              message: '取消输入'
            });
          });
        },
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/dict.vue